export default "__VITE_ASSET__Cmz7GEkQ__"